"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _MailerSendPlugin = /*#__PURE__*/ _interop_require_default(require("./MailerSendPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _MailerSendPlugin.default,
    id: 'mailersend',
    title: 'MailerSend',
    version: '0.0.2',
    logo: 'plugins/mailersend.svg',
    // icon: 'mdi-email-outline',
    description: 'MailerSend email client',
    price: 'Free',
    tags: 'Email',
    category: 'Email',
    inputs: {
        title: 'Configure MailerSend',
        items: [
            {
                key: 'api_key',
                label: 'API key',
                placeholder: 'eg: ***************',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'from',
                label: 'From',
                placeholder: 'eg: admin@run.com',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'from_name',
                label: 'From name',
                placeholder: 'eg: Adam',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Email notifications are now set up using MailerSend.',
        msgOnUninstall: ''
    }
};
const _default = config;
